<template>
    <div class="section-content">   
        <h2>Defer or award</h2>
        <p>Finally, and very importantly, let the claimant know that there is ‘no such thing as failing’. The claim will either be immediately awarded or deferred. Sometimes a relatively minor aspect needs to be better evidenced and this can be amended by a short written piece or brief interview, at the reviewer’s discretion. A significantly weak claim at SF might need to be revisited in the future, when more leadership experience has been gained, but it is hoped that the mentorship process makes this scenario unlikely. It can be reassuring for claimants preparing for a dialogue route to remind them that the reviewers are looking to recognise the good practice they have been doing via the PSF system, and in this way it is dissimilar to a job interview, a contest, or an examination.</p>

        <h3>Reflective activity</h3>
        <p>On a piece of paper, draw circles representing an assessment, a job interview and a PSF Dialogue. Make the circles into a Venn diagram, thinking carefully about the elements in common, and the distinctions. This might help you articulate the process to colleagues interested in the Dialogue Route. </p>
    </div>

    

</template>

<script>
export default {

}
</script>

<style>

</style>